'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { AskInputContext } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputProviderShared.js';
import { AskInputRoot } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputRoot.js';
import { useAskInputRootActions, useAskInputRootState, useAskInputRootStore, } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputRootShared.js';
import { ThreadConfigContext, useThreadConfig, } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { queryInputStateContextProvider } from '#pplx/frontend/apps/ask/stores/queryInput.js';
import React, { useMemo } from 'react';
const toAskInputProviderStore = (rootStore) => rootStore;
const toQueryInputStore = (rootStore) => rootStore;
const LegacyAskInputContexts = ({ children }) => {
    const rootStore = useAskInputRootStore();
    const rootState = useAskInputRootState();
    const rootActions = useAskInputRootActions();
    const parentThreadConfig = useThreadConfig();
    const threadConfigValue = useMemo(() => ({
        ...parentThreadConfig,
        sources: rootState.sources,
        configuredModel: rootState.configuredModel,
        compareModels: rootState.compareModels,
        exhaustedSearchMode: rootState.exhaustedSearchMode,
        setSources: rootActions.setSources,
        setConfiguredModel: rootActions.setConfiguredModel,
        setCompareModels: rootActions.setCompareModels,
        setExhaustedSearchMode: rootActions.setExhaustedSearchMode,
    }), [
        parentThreadConfig,
        rootActions.setCompareModels,
        rootActions.setConfiguredModel,
        rootActions.setExhaustedSearchMode,
        rootActions.setSources,
        rootState.compareModels,
        rootState.configuredModel,
        rootState.exhaustedSearchMode,
        rootState.sources,
    ]);
    return (_jsx(ThreadConfigContext.Provider, { value: threadConfigValue, children: _jsx(AskInputContext.Provider, { value: toAskInputProviderStore(rootStore), children: _jsx(queryInputStateContextProvider.Provider, { value: toQueryInputStore(rootStore), children: children }) }) }));
};
export const AskInputRootCompatProvider = ({ children, queryDraftKey, defaultSearchModel, defaultSources, defaultCompareModels, workspaceDirectories, }) => {
    const parentThreadConfig = useThreadConfig();
    return (_jsx(AskInputRoot, { queryDraftKey: queryDraftKey, defaultSearchModel: defaultSearchModel ?? parentThreadConfig.configuredModel, defaultSources: defaultSources ?? parentThreadConfig.sources, defaultCompareModels: defaultCompareModels ?? parentThreadConfig.compareModels, workspaceDirectories: workspaceDirectories, children: _jsx(LegacyAskInputContexts, { children: children }) }));
};
//# sourceMappingURL=AskInputRootCompatProvider.js.map